import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rules-and-form-of-payment',
  templateUrl: './rules-and-form-of-payment.component.html',
  styleUrls: ['./rules-and-form-of-payment.component.scss']
})
export class RulesAndFormOfPaymentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
